<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div *ngIf="modalResult !== null"
       class="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success">
    {{ modalResult.text }}
  </div>

  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Association Join Requests
        <span *ngIf="joinRequests">({{ joinRequests.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Association Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingJoinRequests && joinRequestsPresent()">
      <tr *ngFor="let joinRequest of joinRequests">
        <td>
          {{ dateStringFromISO8601(joinRequest.created_at) }}
        </td>
        <td>
          <a [routerLink]="['/customers', joinRequest.customer_id.toString()]">
            {{ joinRequest.customer_first_name }} {{ joinRequest.customer_last_name }}
          </a>
        </td>
        <td>{{ joinRequest.association_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewJoinRequestModal(joinRequest);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingJoinRequests || !joinRequestsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingJoinRequests">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingJoinRequests && !joinRequestsPresent()">
          No outstanding association join requests.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
